import { FileDownload } from "@mui/icons-material";
import { Box, Button, Popover, Typography } from "@mui/material";
import React, { useState } from "react";
import CustomDatePickerInput from "./HrManagements/CustomDatePickerInput";
import LoadButton from "./LoadButton";
import dayjs from "dayjs";
import { API_AXIOS } from "../http/interceptor";
import { saveAs } from "file-saver";
import { Download } from "lucide-react";

const DownloadExcel = ({ api, params = {}, module, customButton }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [startDate, setStartDate] = useState(
    dayjs().subtract(1, "week").startOf("day"),
  );
  const [endDate, setEndDate] = useState(dayjs(Date.now()));
  const [loading, setLoading] = useState(false);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const handleDownload = async () => {
    setLoading(true);
    try {
      const response = await API_AXIOS.get(api, {
        params: {
          ...params,
          exclude: encodeURIComponent(JSON.stringify(params?.exclude || {})),
          downloadExcel: true,
          startDate: startDate ? dayjs(startDate).format("YYYY-MM-DD") : null,
          endDate: endDate ? dayjs(endDate).format("YYYY-MM-DD") : null,
        },
        responseType: "blob",
      });      

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, `${module}.xlsx`);
    } catch (error) {
      console.error("Error downloading the Excel file", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {customButton ?? (
        <div
          className="px-3 py-2 rounded-lg bg-gradient-to-br from-[#f9fbfd] to-white border border-[#739fe1]/20 flex items-center gap-2 hover:bg-white hover:shadow-lg hover:border-[#2e67be]/30 transition-all duration-300 group cursor-pointer"
          title="Export selected leads"
          onClick={handleClick}
        >
          <Download className="w-4 h-4 text-[#739fe1] group-hover:text-[#2e67be] transition-colors" />
          <span className="text-sm text-[#739fe1] group-hover:text-[#2e67be] transition-colors">
            Export
          </span>
        </div>
      )}

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1, m: 1 }}>
          From
          <CustomDatePickerInput
            placeholder="From"
            value={startDate}
            onChange={(newValue) => setStartDate(newValue)}
          />
          To
          <CustomDatePickerInput
            placeholder="To"
            value={endDate}
            onChange={(newValue) => setEndDate(newValue)}
          />
          <LoadButton
            onClick={handleDownload}
            size="small"
            color={"custom"}
            loading={loading}
            variant="contained"
          >
            Export as csv
          </LoadButton>
        </Box>
      </Popover>
    </>
  );
};

export default DownloadExcel;
